"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _nuiLogger = require("@concur/nui-logger");
var _fetchRetry = _interopRequireDefault(require("./fetch-retry"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// eslint-disable-next-line no-unused-vars
var regeneratorRuntime = require('regenerator-runtime');
var _default = exports.default = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee(apigwUrl) {
    var response, responseText;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            responseText = '';
            if (apigwUrl.startsWith('http://')) {
              apigwUrl = apigwUrl.replace('http://', 'https://');
            }
            _context.prev = 2;
            _context.next = 5;
            return (0, _fetchRetry.default)("".concat(apigwUrl, "/clear-cookie"), {
              method: 'get',
              redirect: 'manual',
              timeout: 5000,
              retries: 2,
              retryOn: [500, 504],
              retryDelay: 500,
              credentials: 'include'
            });
          case 5:
            response = _context.sent;
            _context.next = 8;
            return response.text();
          case 8:
            responseText = _context.sent;
            if (!(response.status === 200)) {
              _context.next = 13;
              break;
            }
            return _context.abrupt("return", responseText);
          case 13:
            throw responseText;
          case 14:
            _context.next = 19;
            break;
          case 16:
            _context.prev = 16;
            _context.t0 = _context["catch"](2);
            throw new _nuiLogger.CategorizedError(_context.t0, {
              cause: _objectSpread({
                responseText: responseText
              }, response),
              category: 'nui-auth-api',
              subcategory: 'apigw-set-cookie-failure'
            });
          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 16]]);
  }));
  return function (_x) {
    return _ref.apply(this, arguments);
  };
}();